import { TranslateService } from '@ngx-translate/core';
import { getTranslatedTime } from './get-translated-time';

export const calculateTimeDifference = (inputDate: string | Date, translateService: TranslateService): string => {
    const targetDate = new Date(inputDate);
    const now = new Date();

    const diffMilliseconds = now.getTime() - targetDate.getTime();
    if (diffMilliseconds < 1000 || diffMilliseconds < 0) {
        return translateService.instant("à l'instant");
    }

    const seconds = Math.floor(diffMilliseconds / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (seconds < 60) return getTranslatedTime('seconde', seconds, translateService);
    if (minutes < 60) return getTranslatedTime('minute', minutes, translateService);
    if (hours < 24) return getTranslatedTime('heure', hours, translateService);
    if (days < 30) return getTranslatedTime('jour', days, translateService);

    const nowY = now.getFullYear(), nowM = now.getMonth();
    const targetY = targetDate.getFullYear(), targetM = targetDate.getMonth();
    const totalMonths = (nowY - targetY) * 12 + (nowM - targetM);

    if (totalMonths < 12) return getTranslatedTime('mois', totalMonths, translateService);

    const years = Math.floor(totalMonths / 12);
    return getTranslatedTime('année', years, translateService);
};